import { showNotification } from '../../toast';

export default function ReplanOrder(url, parent, order) {
  // eslint-disable-next-line no-undef
  this.contentWindow = new ContentWindow({
    width: (window.innerWidth * 0.8) + 'px',
    zIndex: 2010,
    parent: parent,
    url: url,
    closeButtonLabel: 'Annuleren',
    toolbarButtons: [
      {
        id: 'order_save',
        position: 'right',
        label: 'Herinplannen en sluiten',
        order: 1,
        classNames: 'btn btn-primary order-save',
        action: 'order-save'
      }
    ],
    hideCallbackOnSubmit: function () {
      this.openLastOrderInformation();
    }.bind(this)
  });

  this.order = order;

  this.supplierRemark = null;

  this.replan(url);
}

ReplanOrder.prototype.confirmModification = function (callback) {
  const self = this;
  const vm = $(this.contentWindow.elm);

  let supplierRemarkElm = $('#order_supplierRemark', vm);

  if (supplierRemarkElm.length === 0) {
    supplierRemarkElm = $('#composition_order_supplierRemark', vm);
  }

  const html = `
        <div class="fields" style="font-size: 15px;">
            <div class="field">
                <input id="confirm_phone_contact" type="checkbox">
                <label for="confirm_phone_contact">Er is telefonisch overleg geweest met de leverancier</label>
            </div>
            <div class="field" style="display: none; margin-top: 1rem">
                <label><strong>Aanvullen opmerkingen voor leverancier:</strong></label>
                <textarea id="confirm_supplier_remark" placeholder="Type hier een opmerking voor de leverancier" style="display: block; width: 100%; border-color: #ddd; min-height: 250px;"></textarea>
            </div>
        </div>
    `;

  return swal({
    type: 'warning',
    title: 'Order toch bewerken?',
    html: html,
    showCancelButton: true,
    confirmButtonText: 'Bewerken',
    reverseButtons: true,
    onOpen: function () {
      $('.swal2-container').css({
        'z-index': 9001
      });

      const confirmSupplierRemarkElm = $('#confirm_supplier_remark');

      $('#confirm_phone_contact').on('change', function () {
        const elm = $(this);
        const isChecked = elm.prop('checked');

        confirmSupplierRemarkElm.val(supplierRemarkElm.val());
        confirmSupplierRemarkElm.closest('.field').toggle(isChecked);
      });

    },
    preConfirm: function (values) {
      return new Promise((resolve, reject) => {
        const isChecked = $('#confirm_phone_contact').prop('checked');
        if (isChecked) {
          resolve();
        } else {
          reject('Bevestiging is verplicht.');
        }
      });
    }
  }).then(() => {
    const confirmSupplierRemarkElm = $('#confirm_supplier_remark');
    const text = confirmSupplierRemarkElm.val();

    supplierRemarkElm.val(text);
    self.supplierRemark = text;

    if (typeof callback === 'function') {
      callback();
    }
  }).catch(swal.noop);
};

ReplanOrder.prototype.can = function (action, callback) {
  const orderEditElm = $("#order_edit", this.contentWindow.elm);
  const canEditOrderComposition = !!orderEditElm.data('can-edit-order-composition');
  const canEditDeliveryAddress = !!orderEditElm.data('can-edit-delivery-address');
  const canEditDeliveryDate = !!orderEditElm.data('can-edit-delivery-date');
  const isLocked = !!orderEditElm.data('edit-is-locked');

  if (action === 'edit_order_composition' && !canEditOrderComposition && !isLocked) {
    this.confirmModification(callback);
    return;
  }

  if (action === 'edit_delivery_address' && !canEditDeliveryAddress && !isLocked) {
    this.confirmModification(callback);
    return;
  }

  if (action === 'edit_delivery_date' && !canEditDeliveryDate && !isLocked) {
    this.confirmModification(callback);
    return;
  }

  if (typeof callback === 'function') {
    callback();
  }
};

ReplanOrder.prototype.replan = function (url) {
  var self = this;

  this.url = url;
  this.contentWindow.empty().show();

  $.get(url).done(function (data) {
    self.contentWindow.setHtml(data);

    self.initialize();
  }).fail(function () {

  });
};

ReplanOrder.prototype.initialize = function () {
  cms.getElements().initElementDate();

  this.orderLinesIndex = $('#order_overview').find('.order-line').length - 1;
  this.lastGeneratedUuid = null;

  $('[data-element="metadata"]', this.contentWindow.elm).parent('td').addClass('metadata');

  this.bindEvents();
};

ReplanOrder.prototype.toggleDisableOrderEdit = function (disabled) {
  var orderOverviewElm = $('#order_overview');

  // Force display of add/edit product button
  $('#order_edit_add_product').toggle(!disabled);
  $('#order_edit .line-delete').toggle(!disabled);

  $('input[data-element="quantity"]', orderOverviewElm).prop('disabled', disabled);
  $('select[data-element="product"]', orderOverviewElm).prop('disabled', disabled);
  $('input[data-element="discount-amount"]', orderOverviewElm).prop('disabled', disabled);
  $('textarea[data-element="metadata"]', orderOverviewElm).prop('disabled', disabled);

  $('input[name="order[disableOrderEdit]"]', this.contentWindow.elm).val(disabled ? '1' : '0');

  orderOverviewElm.toggleClass('disabled', disabled);
};

ReplanOrder.prototype.editComposition = function (result) {
  const self = this;
  const btnElm = $('#change_composition', this.contentWindow.elm);
  const url = btnElm.data('edit-composition-url');
  const contentWindow = $(this.contentWindow.elm);

  $.ajax({
    url: url,
  }).then(function (html) {

    this.contentWindow.setHtml(html);
    this.bindEvents();

    const saveButton = $('.content-window-toolbar a[data-action="order-save"]');
    const orderNumberContainer = $('#order_number', contentWindow.elm);

    orderNumberContainer
      .attr('data-old-number', orderNumberContainer.html())
      .html(result.number)
      .append('<span class="label draft heading-text bg-grey-300">Concept</span>')
      .nextAll($('.label:not(.draft)'))
      .remove();

    $(`<div class="save-notice">Let op: Na het opslaan zal order ${orderNumberContainer.attr('data-old-number')} worden geannuleerd, order ${result.number} wordt toegevoegd.</div>`).insertBefore(saveButton);

    saveButton
      .text('Gewijzigde samenstelling opslaan')
      .removeClass('btn-primary')
      .addClass('bg-success');

    // Support both forms
    if (self.supplierRemark) {
      $("#order_supplierRemark", this.contentWindow.elm).val(self.supplierRemark);
      $("#composition_order_supplierRemark", this.contentWindow.elm).val(self.supplierRemark);
      self.supplierRemark = null;
    }
  }.bind(this))
};

ReplanOrder.prototype.enablePanelFields = function (panelElm) {
  const fields = $("input, select, textarea", panelElm);

  fields.removeAttr('readonly');
  fields.removeAttr('disabled');
};

ReplanOrder.prototype.bindEvents = function () {
  var self = this;
  var disabled = $('#change_composition:visible').length > 0;
  var contentWindow = $(this.contentWindow.elm);

  this.initializeAddressCheck();
  this.initializeSwitchery();
  this.toggleDisableOrderEdit(disabled);
  this.addressLookup();


  contentWindow.unbind()
    .on('click', 'button[data-action=select-supplier]', function (e) {
      e.preventDefault();

      $('#order_process_supplier', self.contentWindow.elm).val($(this).data('id'));

      $('form', self.contentWindow.elm).trigger('submit');
    });

  contentWindow.on('click', '.delivery-information-toggle', function () {
    $(this).closest('.delivery-information').toggleClass('open');
  });

  contentWindow
    .on('click', '[data-action=order-save]', function (e) {

      e.preventDefault();

      var elm = $(this);
      var form = elm.parents('.content-window').find('form');

      form.validate();

      if (form.isValid()) {
        elm.attr('disabled', 'disabled');
        elm.html(`<i class="fa fa-spinner fa-spin"></i> ${elm.html()}`);

        form.trigger('submit');
      }
    });

};

ReplanOrder.prototype.initializeAddressCheck = function () {
  var self = this;
  var originalAddress = self.addressToHtml();

  $(':input[name^="order[deliveryAddress]"]', this.contentWindow.elm).on('change', function () {
    var modifiedAddress = self.addressToHtml();

    swal({
      title: 'Het afleveradres is gewijzigd.',
      text: '<p>Is deze wijziging van toepassing op deze order of dient deze wijziging ook op alle toekomstige bestellingen te worden doorgevoerd?!</p>\
            <table style="text-align: left; width: 100%;">\
            <tr><th><strong>Oorspronkelijk adres</strong></th><th><strong>Gewijzigd adres</strong></th></tr>\
            <tr><td>' + originalAddress + '</td><td>' + modifiedAddress + '</td></tr>\
            </table>',
      type: 'warning',
      html: true,
      showCancelButton: true,
      confirmButtonColor: '#2196F3',
      confirmButtonText: 'Ja, adres bij klant ook wijzigen!',
      cancelButtonText: 'Nee',
      closeOnConfirm: false,
      closeOnCancel: false,
      animation: false
    });
  });
};

ReplanOrder.prototype.addressToHtml = function () {
  var html = '';

  html += $('input[name="order[deliveryAddress][companyName]"]').val() + '<br />';
  html += $('input[name="order[deliveryAddress][attn]"]').val() + '<br />';
  html += $('input[name="order[deliveryAddress][street]"]').val() + ' ';
  html += $('input[name="order[deliveryAddress][number]"]').val() + '<br />';
  html += $('input[name="order[deliveryAddress][postcode]"]').val() + ' ';
  html += $('input[name="order[deliveryAddress][city]"]').val() + '<br />';
  html += $('select[name="order[deliveryAddress][country]"] option:selected').text() + '<br />';
  html += $('input[name="order[deliveryAddress][phoneNumber]"]').val() + '<br />';

  return html;
};

ReplanOrder.prototype.initializeSwitchery = function () {
  var self = this;

  var input = $('input.switchery', this.contentWindow.elm);

  input.on('change', function () {
    var state = $(this).is(':checked');

    $('.total-line-vat, .total-line-price-excl').toggle(!state);
    $('.total-line-placeholder').toggle(!state);

    self.calculateTotals(state);
  }).trigger('change');

  new Switchery(input.get(0));
};

ReplanOrder.prototype.calculateTotals = function (isIncl) {
  if (!isIncl) {
    isIncl = $('input.switchery', this.contentWindow.elm).is(':checked');
  }

  const quantityElm = $('.element-quantity', this.contentWindow.elm);

  if (quantityElm.length === 0) {
    return;
  }

  let totalPrice = 0;
  let totalPriceIncl = 0;

  $.each($('#order_overview tr.order-line'), function (i, elm) {
    const quantity = $('.element-quantity', $(elm)).val();
    const price = $('.element-price', $(elm)).val();
    const priceIncl = $('.element-price-incl', $(elm)).val();
    const lineTotal = parseFloat(price.replace(',', '.')) * quantity;
    const lineTotalIncl = parseFloat(priceIncl.replace(',', '.')) * quantity;

    totalPrice += lineTotal;
    totalPriceIncl += lineTotalIncl;

    $(elm).find('td.line-price-total span.text').html(priceFilter(
      isIncl ? lineTotalIncl : lineTotal,
      isIncl ? 2 : 3
    ));
  }.bind(this));

  $('.total-line-price-excl span.text', '#order_overview').html(priceFilter(totalPrice, 3) || 0);
  $('.total-line-vat span.text', '#order_overview').html(priceFilter(totalPriceIncl - totalPrice, 2) || 0);
  $('.total-line-price-incl span.text', '#order_overview').html(priceFilter(totalPriceIncl, 2) || 0);
};

ReplanOrder.prototype.addressLookup = () => {
  const triggerElement = document.getElementById('address-autocomplete-lookup')
  const queryElement = document.getElementById('address-autocomplete-query')
  const copyElement = document.getElementById('address-autocomplete-copy')
  const addressStreetInput = document.getElementById('order_deliveryAddressStreet')
  const addressNumberInput = document.getElementById('order_deliveryAddressNumber')
  const addressNumberAdditionInput = document.getElementById('order_deliveryAddressNumberAddition')
  const addressPostcodeInput = document.getElementById('order_deliveryAddressPostcode')
  const addressCityInput = document.getElementById('order_deliveryAddressCity')

  const country = document.querySelectorAll('[data-country-code]')
  const contextElement = document.createElement('input')
  contextElement.setAttribute('type', 'hidden')
  contextElement.setAttribute('id', 'address-autocomplete-context')
  contextElement.value = country[0].dataset.countryCode === 'BE' ? 'bel' : 'nld'

  if (triggerElement) {
    triggerElement.appendChild(contextElement)
    document.dispatchEvent(new Event('addressAutocomplete:loaded'))
    triggerElement.addEventListener('click', (e) => {
      e.preventDefault()
      queryElement.value = triggerElement.dataset.addressLookup
      queryElement.focus()
    })
  }

  if (copyElement) {
    copyElement.addEventListener('click', (e) => {
      e.preventDefault()
      addressStreetInput.value = copyElement.dataset.street
      addressNumberInput.value = copyElement.dataset.number
      addressNumberAdditionInput.value = copyElement.dataset.numberAddition
      addressPostcodeInput.value = copyElement.dataset.postcode
      addressCityInput.value = copyElement.dataset.city
      showNotification({text: 'Adres aangepast'})
    })
  }
}
